module.exports = __webpack_public_path__ + "img/boogo_pumpkin-light.7b8a4043.png";